import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorHandlingService } from '../../core/services/error-handling.service';
import { ApiRespons } from '../../features/manage-organization/manage-organization.interface';
export interface Role {
  id: number;
  name: string;
}

export interface RoleDescriptionItem {
  role: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly API_URL = `${environment.apiUrl}/Role`;
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlingService);
  getAllRoles(): Observable<ApiRespons<Role>> {
    return this.http
      .get<ApiRespons<Role>>(this.API_URL, { withCredentials: true })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  getRoleDescriptions(): Observable<Record<string, string>> {
    return this.http
      .get<RoleDescriptionItem[]>('/assets/role-descriptions.json')
      .pipe(
        map(descriptions =>
          descriptions.reduce(
            (acc, item) => {
              acc[item.role] = item.description;
              return acc;
            },
            {} as Record<string, string>
          )
        ),
        catchError(() => of({}))
      );
  }
}
